import { useParams } from 'react-router'
import { UserPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import { LittleModalCreateEdit } from '../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import { ModalComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import { FormElement, FormRender } from '../../../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { BillingGroupSupplierRelModelType } from '@teinor/erp/types/company/config/billingGroup/billingGroupSupplierRel'
import { useCallback, useEffect,  useState } from 'react'
import { twinFetchPostJSON } from '../../../../../../../../../utils/globals/data'
import withLoading from '../../../../../../../../../utils/hoc/withLoading'
import { BillingGroupPayload, DictionaryBillingGroupTy } from '../../../../../../../../../utils/reducers/company/billingGroups'
import { AllReduxPayloads } from '../../../../../../../../../utils/reducers'
import { ConnectedProps, connect } from 'react-redux'
import { BeforeSubmitHandler } from '../../../../../../../../../forms/TwinForm/types'
import { RowData } from '../../../../../../../../../baseComponents/TwinTable/types'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'

type ModalCESupplierBillingGroupProps = ModalComponentProps & ReduxModalCESupplierBillingGroupConnector &{
    allRowData?: RowData
    userPermissions?: UserPermissions
}

const ModalCESupplierBillingGroup: React.FC<ModalCESupplierBillingGroupProps> = ({ userPermissions, allRowData, billingGroups, ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleSelectedBillingGroupId, id, selectedBillingGroups, selectedBillingGroupId, parseBTOBeforeSubmit } = useModalCESupplierBillingGroupsLogic({ billingGroups: billingGroups?.dictionaryBillingGroup || {}, allRowData})
    const extraBillingTypesBuy: FormElement<any>[] = []
    if (selectedBillingGroupId) {
        const billingTypesBuy = billingGroups?.dictionaryBillingGroup?.[selectedBillingGroupId].billingTypesBuyDict || {}
        if (billingTypesBuy && Object.keys(billingTypesBuy).length) {
            let myDefaultValues: TwinDictionary = {}
            if (allRowData?.BillingTypeBuyOptions){
                for (const option of allRowData?.BillingTypeBuyOptions) {
                    const myOptionComplete = billingGroups?.billingTypesAllBuyOptions[option]
                    myDefaultValues[myOptionComplete?.BillingTypeBuyId || 0] = option
                }
            }
            for (const idParent in billingTypesBuy) {
                const type = billingTypesBuy[idParent];
                let defaultValue = myDefaultValues[idParent] || type.DefaultBillingTypeBuyOptionId
                extraBillingTypesBuy.push({
                    label: type.name + ' - ' + t('default', 'Por defecto'),
                    name: 'BTO_' + type.id,
                    component: 'CustomSelectWithSearchBar',
                    items: type.billingTypeBuyOptionsDict || {},
                    required: type.mandatory,
                    value: defaultValue
                })
            }
        }
    }
    const billingGroup: FormElement<keyof BillingGroupSupplierRelModelType>[] = []
    
    if(allRowData?.BillingGroupId){
        billingGroup.push(
            {
                name: 'BillingGroupId',
                label: t('billingGroup', 'Grupo de facturación'),
                items: billingGroups?.dictionaryBillingGroup || {},
                component: 'CustomSelectWithSearchBar',
                required: true,
                readOnly: true,
                onChange: handleSelectedBillingGroupId
            },
        )
    } else {
        billingGroup.push(
            {
                name: 'BillingGroupId',
                label: t('billingGroup', 'Grupo de facturación'),
                items: billingGroups?.dictionaryBillingGroup || {},
                component: 'CustomSelectWithNotInFilteredItems',
                excludeItems: selectedBillingGroups,
                required: true,
                readOnly: selectedBillingGroups.length === Object.keys(billingGroups?.dictionaryBillingGroup || {}).length ? true : false,
                onChange: handleSelectedBillingGroupId
            },
        )
    }

    const fields: FormRender<BillingGroupSupplierRelModelType> = [
        {
            cols: 1,
            elements: [
                ...billingGroup,
                {
                    name: 'SupplierId',
                    component: 'InputHidden',
                    value: id
                },
                ...extraBillingTypesBuy
            ],
        }
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit beforeSubmit={parseBTOBeforeSubmit} fields={parsedFields} url={'/api/app/supplier/supplierBillingGroup/updateBillingGroupSupplier'} translations={{ title: t('editSupplierBillingGroup', 'Editar Grupo de Facturación de proveedor'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<LittleModalCreateEdit beforeSubmit={parseBTOBeforeSubmit} fields={fields} url={'/api/app/supplier/supplierBillingGroup/assignBillingGroupToSupplier'} translations={{
        title: t('createSupplierBillingGroup', 'Crear Grupo de Facturación de proveedor'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}
interface ModalCESupplierBillingGroupLogicProps {
    billingGroups: DictionaryBillingGroupTy
    allRowData?: RowData
}

const useModalCESupplierBillingGroupsLogic = ({ billingGroups, allRowData }: ModalCESupplierBillingGroupLogicProps) => {
    const [selectedBillingGroups, setSelectedBillingGroups] = useState<string[]>([])
    const [selectedBillingGroupId, setSelectedBillingGroupId] = useState<number | null>(null)
    const { id } = useParams()
    const handleSelectedBillingGroupId = useCallback((BillingGroupId: number) => {
        setSelectedBillingGroupId(BillingGroupId)
    }, [setSelectedBillingGroupId])

    const getSelectedBillingGroups = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/supplier/supplierBillingGroup/getAllBillingGroupsSuppliers', { where: { 'SupplierId': id } })
        const selected: string[] = []
        for (const selectedBillingGroup of result) {
            selected.push(String(selectedBillingGroup.BillingGroupId))
        }
        setSelectedBillingGroups(selected)
    }, [setSelectedBillingGroups, id])

    const parseBTOBeforeSubmit: BeforeSubmitHandler = useCallback((vals) => {
        const result: number[] = []
        if (selectedBillingGroupId){
            const billingTypesBuy = billingGroups[selectedBillingGroupId].billingTypesBuyDict
            for (const key in billingTypesBuy) {
                const billingType = billingTypesBuy[parseInt(String(key))]
                const index = 'BTO_' + billingType.id
                const element = vals[index];
                result.push(element)
            }
            vals['BillingTypeBuyOptions'] = result
            return true
        }
        return false
    }, [selectedBillingGroupId, billingGroups])

    useEffect(() => {
        getSelectedBillingGroups()
    }, [getSelectedBillingGroups])

    useEffect(() => {
        if(allRowData?.BillingGroupId){
            setSelectedBillingGroupId(allRowData?.BillingGroupId)
        }
    }, [allRowData?.BillingGroupId])

    return { id, selectedBillingGroups, handleSelectedBillingGroupId, selectedBillingGroupId, parseBTOBeforeSubmit }
}

const modalCESupplierBillingGroupDispatch = {
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
}
const mapModalCESupplierBillingGroupConnector = (state: AllReduxPayloads) => ({ billingGroups: state.billingGroups })
const modalCESupplierBillingGroupConnector = connect(mapModalCESupplierBillingGroupConnector, modalCESupplierBillingGroupDispatch)
type ReduxModalCESupplierBillingGroupConnector = ConnectedProps<typeof modalCESupplierBillingGroupConnector>

const modalCESupplierBillingGroupConnectLoading = withLoading(ModalCESupplierBillingGroup, [{ fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups'}])
const ModalCESupplierBillingGroupConnect = modalCESupplierBillingGroupConnector(modalCESupplierBillingGroupConnectLoading)
export default ModalCESupplierBillingGroupConnect
